var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QImage2',{attrs:{"relativePath":_vm.relativePath,"size":_vm.size,"fallbackIcon":'$customer_group',"openPickerOnClick":_vm.editable,"editable":_vm.editable},on:{"File":function (file) { return _vm.$emit('File', file); }}})}
var staticRenderFns = []

export { render, staticRenderFns }